import { Pregnancy } from "@/model/Pregnancy"
import LabeledText from "@/pages/patient-details/LabeledText"
import EditPregnancyModal from "@/pages/patient-details/pregnancy/EditPregnancyModal"
import { formatDate } from "@/utils/date-utils"
import { useState } from "react"

type PregnancyInfoProps = {
  bloomlifeId: string
  pregnancy: Pregnancy
}

const PregnancyInfo = ({ bloomlifeId, pregnancy }: PregnancyInfoProps) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)

  return (
    <div className="rounded-xl bg-white p-4 shadow-md shadow-black/5">
      <div className="flex items-center justify-between">
        <div className="grid flex-1 grid-cols-3 gap-4">
          <LabeledText
            label="Estimated delivery date"
            value={
              pregnancy.estimatedDateOfDelivery &&
              formatDate(pregnancy.estimatedDateOfDelivery, "MM/dd/yyyy")
            }
          />
          <LabeledText
            label="Delivery date"
            value={
              pregnancy.deliveryDate &&
              formatDate(pregnancy.deliveryDate, "MM/dd/yyyy")
            }
          />
          <LabeledText
            label="Patient opted in clinically"
            value={pregnancy.patientOptedInClinically ? "Yes" : "No"}
          />
        </div>
        <span
          className="material-icons-outlined cursor-pointer text-[24px] text-primary/60 transition-colors hover:text-primary"
          onClick={() => setIsEditModalOpen(true)}
        >
          edit
        </span>
      </div>

      <EditPregnancyModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        bloomlifeId={bloomlifeId}
        pregnancy={pregnancy}
      />
    </div>
  )
}

export default PregnancyInfo
